module.exports = __webpack_public_path__ + "img/Number=33.abb99584.png";